<template>
    <footer
        class="block-footer"
        :class="device_platform"
    >
        <div class="block-footer__inner">
            <p class="block-footer__legal-text">
                Данный сайт носит исключительно информационно-справочный характер. Не является публичной офертой. Для получения подробной информации обращайтесь по телефону
                <a :href="'tel:' + phone_raw" class="contacts-info__phone">{{ phone }}</a> и в Технический Центр Кунцево.<br>
                Опубликованная на сайте информация может быть изменена в любое время без предварительного уведомления
            </p>
            <div class="block-footer__links">
                <ul class="block-footer__social-list custom-list">
                    <li class="block-footer__social-item">
                        <a href="http://vk.com/tckuntsevo" class="block-footer__social-link icon-vk"></a>
                    </li>
                    <!-- <li class="block-footer__social-item">
                        <a href="https://www.facebook.com/tckuntsevo" class="block-footer__social-link icon-fb"></a>
                    </li>
                    <li class="block-footer__social-item">
                        <a href="https://www.instagram.com/tc_kuntsevo/" class="block-footer__social-link icon-inst"></a>
                    </li> -->
                </ul>
                <ul class="block-footer__app-list custom-list">
                    <li class="block-footer__app-item">
                        <a href="https://apps.apple.com/ru/app/tc-kuncevo/id1057748178" class="block-footer__app-link icon-app_store"></a>
                    </li>
                    <li class="block-footer__app-item">
                        <a href="https://apps.rustore.ru/app/com.brightbox.dm.tehnicheskitsentrkuntsevo" class="block-footer__app-link icon-ru_store"></a>
                    </li>
                </ul>
            </div>
            <!-- <p class="block-footer__public-text">
                *Наклейки получают лучшие организации, которые пользователи Яндекса оценивают минимум на четыре балла из пяти. Рейтинг доступен на Картах, в Навигаторе и поиске Яндекса по результатам 2019 года.
            </p> -->
        </div>
    </footer>
</template>

<script>
import Mixin from '@/common/mixin'

export default {
    name: 'block-footer',
    mixins: [Mixin],
    data() {
        return {
            ...this.CONSTANTS
        }
    }
}
</script>

<style scoped lang="scss">
.block-footer {
    padding: 60px;

    color: #fff;

    background-color: #212121;

    @media (max-width: 320px) {
        padding: 20px;
    }

    &__inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 1440px;
        margin: auto;
    }

    &__legal-text {
        margin: auto;
        margin-bottom: 50px;

        text-align: center;
    }

    &__links {
        display: flex;
        align-items: center;
        margin-bottom: 35px;
    }

    &__social-list {
        display: flex;
        margin-right: 50px;
    }

    &__social-item {
        width: 60px;
        height: 60px;
        margin-right: 50px;

        @media (max-width: 320px) {
            margin-right: 10px;
        }

        &:last-child {
            margin-right: 0;
        }
    }

    &__app-list {
        display: flex;

        @media (max-width: 320px) {
            flex-wrap: wrap;
        }
    }

    &__app-item {
        width: 150px;
        height: 45px;
        margin-right: 15px;

        border-radius: 8px;

        @media (max-width: 320px) {
            margin-bottom: 10px;
        }
    }

    &__public-text {
        font-size: 12px;
    }

    @each $icon in 'vk', 'fb', 'inst', 'app_store', {
        .icon-#{$icon}::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            background-image: url("../img/icons/#{$icon}.png");
            background-repeat: no-repeat;
            background-position: center center;
        }
    }

    .icon-ru_store::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: url("../img/icons/rustore.svg");
        background-repeat: no-repeat;
        background-position: center center;
    }
}

.mobile {
    .block-footer {
        &__links {
            flex-direction: column;
        }

        &__social-list {
            margin-right: 0;
            margin-bottom: 20px;
        }

        &__app-list {
            justify-content: center;
        }

        &__app-item {
            margin-right: 10px;
            width: 140px;
        }
    }
}

.contacts-info__phone {
    text-decoration: none;
    color: #fff;
}
</style>
